import { render, staticRenderFns } from "./CriaTokenEmissor.vue?vue&type=template&id=1f0ee879"
import script from "./CriaTokenEmissor.vue?vue&type=script&lang=js"
export * from "./CriaTokenEmissor.vue?vue&type=script&lang=js"
import style0 from "./CriaTokenEmissor.vue?vue&type=style&index=0&id=1f0ee879&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports